import { Component, OnInit, Input, Output, forwardRef, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { ListObject } from '../models/dplist.model';
import { QuestionnaireService } from '../services/questionnaire.service';
import { SystemTablesService } from '../services/system-tables.service';
//import { environment } from 'environments/environment';

export interface Prefix {
	mkey: string;
	mtext: string;
	mEngText: string;
}

@Component({
	selector: 'phone-number',
	templateUrl: './phone-number.component.html',
	styleUrls: ['./phone-number.component.scss'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => PhoneNumberComponent),
			multi: true
		},
		// {
		// 	provide: NG_VALIDATORS,
		// 	useExisting: forwardRef(() => PhoneNumberComponent),
		// 	multi: true,
		// }
	]
})

export class PhoneNumberComponent implements ControlValueAccessor, OnInit {
	placeholderVisible = true;
	@Input('value') _value: string = '';
	@Input() mobilePrefixOnly: boolean;
	@Input() isMobile: boolean;
	@Input() customClass: string = '';
	@Input() ariaLabel: string = '';
	@Input() ariaLabelPre: string = '';
	@Output() isMobileChange: EventEmitter<any> = new EventEmitter<any>();
	@Output() onNumberChange: EventEmitter<string> = new EventEmitter<string>();
	@Output() onCompleteFill: EventEmitter<string> = new EventEmitter<string>();
	// public inputControl = new FormControl('');
	inputControl: FormControl;
	onChange: any = () => { };
	onTouched: any = () => { };
	currentNumber = '';
	submitted: boolean = false;
	currentPre = null;
	defaultValue = "";
	formGroup: FormGroup;

	prefixesObjArr: ListObject = { id: 0, name: 'בחר' };
	mobilePrefixes = ["050", "052", "053", "054", "055", "056", "057", "058", "059"];
	// stationryPrefixes = ["02", "03", "04", "08", "09", "071", "072", "073", "074", "076", "077", "079"]
	stationryPrefixes = []

	prefixes: any
	private parseError: boolean;

	constructor(public systemTablesService: SystemTablesService, private _changeDetector: ChangeDetectorRef, private questionnaireService: QuestionnaireService) {
		// this.systemTablesService.phonePrefixes.subscribe(data => {
		// 	console.log("GAL--->phonePrefixes", data)
		// 	this.prefixes = data;
		// });
		this.inputControl = new FormControl('');
	}


	get value() {
		return this._value;
	}
	selectValue(value: ListObject) {
		this.currentPre = value.name;
	}

	set value(val) {
		this._value = val;

		this.onChange(val);
		this.onTouched();
	}

	registerOnChange(fn) {
		this.onChange = fn;
	}

	registerOnTouched(fn) {
		this.onTouched = fn;
	}

	writeValue(value) {
		if (value) {
			this.value = value;
			this._changeDetector.markForCheck();
			this.setPrefixAndNumber();
			this.onNumberChange.emit(this.value);
		}
	}

	// propagateChange = (_: any) => {

	// };

	ngOnInit() {
		this.questionnaireService.submitted$.subscribe(isSubmitted => {
			if (isSubmitted) {
				this.inputControl.markAsTouched();
				this.submitted = true;
				if (!this._changeDetector['destroyed']) {
					this._changeDetector.detectChanges();
				}
			} else {
				this.submitted = false;
			}

		})
		// this.getSystemTbl()
		this.currentPre = this.defaultValue;

		this.prefixes = this.mobilePrefixes;
		// this.prefixes = this.mobilePrefixOnly ? this.prefixes : this.stationryPrefixes.concat(this.prefixes)
		// this.currentPre = this.prefixes[0];

		if (this.value) {
			this.setPrefixAndNumber();
		}

	}


	setPrefixAndNumber() {
		let pre1 = this.value.toString().substring(0, 2);
		let pre2 = this.value.toString().substring(0, 3);

		let stationaryPre = this.stationryPrefixes.includes(pre1) ? pre1 : (this.stationryPrefixes.includes(pre2) ? pre2 : '')
		let mobilePre = this.prefixes.includes(pre2) ? pre2 : '';

		if (stationaryPre && !this.mobilePrefixOnly) {
			this.currentPre = stationaryPre;
			this.currentNumber = this.value.toString().substring(stationaryPre.length);
		} else if (mobilePre) {
			this.currentPre = mobilePre;
			this.currentNumber = this.value.toString().substring(mobilePre.length);
		} else {
			this.value = '';
			this.onNumberChange.emit(this.value);
		}
	}

	onPreChange(val) {
		this.currentPre = val;
		this.value = this.currentPre + this.currentNumber;
		this.isMobile = this.prefixes.includes(val);
		this.isMobileChange.emit(this.isMobile);
		this.onNumberChange.emit(this.value);

		this.checkIfComplete();
	}

	onChangeNumber(val) {
		this.currentNumber = val;
		this.value = this.currentPre + this.currentNumber;
		this.onNumberChange.emit(this.value);
		if (this.currentNumber.length >= 7) {
			this.checkIfComplete();
		}
	}

	checkIfComplete() {
		if (this.value.length >= 10) {
			console.log('checkIfComplete 2', this.value)
			this.onCompleteFill.emit(this.value);
		}
	}
}







// WEBPACK FOOTER //
// ./src/app/phone-number/phone-number.component.ts